// Everything this slice caches. Both writes invalidate at the CARRIER level, so a second carrier's
// list is never refetched by the first one's write.
export const CARRIER_EXCLUSION_LISTS_PREFIX = ['carrier-exclusion-lists'] as const;

export const carrierExclusionListKey = (slug: string) =>
  [...CARRIER_EXCLUSION_LISTS_PREFIX, slug] as const;

export const excludedUsersKey = (slug: string) => [...carrierExclusionListKey(slug), 'users'] as const;
